import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { privateRoutes, routes } from "./pages/index";
import AuthLayout from "./layout/Auth/authLayout";
import MainLayout from "./layout/MainLayout/MainLayout";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";

import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-datepicker/dist/react-datepicker.css";
import "./Assets/css/style.css";
import { ACCEPT_TERMS_AND_CONDITIONS, PRIVACY_POLICY, TASK_ONBOARD, TERMS_AND_CONDITIONS } from "config/paths";
import AcceptTerms from "pages/AcceptTerms/Index";
import TaskOnboard from "pages/Onboard";
import OnboardLayout from "layout/OnboardLayout/OnBoardLayout";

function App() {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const user = useSelector(state => state.auth.user);
  return (
    <>
      <Routes>
        {/* Public Routes */}
        {!isAuthenticated ? (
          <Route element={<AuthLayout />}>
            <Route index element={<Navigate to="/login" />} />
            {routes.map((data, index) => (
              <Route
                onUpdate={() => window.scrollTo(0, 0)}
                exact={true}
                path={data.path}
                element={data.component}
                key={index}
              />
            ))}
            <Route path="*" element={<Navigate to="/login" />} />
          </Route>
        ) : (
          <Route element={<Navigate to="/client/school" />} />
        )}

        {
          isAuthenticated && (
            <Route element={<OnboardLayout />}>
              <Route path={TASK_ONBOARD} element={<TaskOnboard />} />
            </Route>
          )
        }

        {/* Private Routes */}
        {isAuthenticated ? (
          // user?.termsAndConditionsStatus !== "accepted" ? (
          //   // Redirect all private routes to the terms acceptance page
          //   <Route element={<TermsLayout />}>
          //     <Route path={TERMS_AND_CONDITIONS} element={<TermsAndConditions />} />
          //     <Route path={PRIVACY_POLICY} element={<PrivacyPolicy />} />
          //     <Route path={ACCEPT_TERMS_AND_CONDITIONS} element={<AcceptTerms />} />
          //     <Route path="*" element={<Navigate to={ACCEPT_TERMS_AND_CONDITIONS} />} />
          //   </Route>
          // ) : 

          (
            <Route element={<MainLayout />}>
              <Route index element={<Navigate to="/my-caseload" />} />

              {privateRoutes.map((data, index) => (
                <Route
                  key={index}
                  exact
                  path={data.path}
                  element={data.component}
                />
              ))}

              <Route path={ACCEPT_TERMS_AND_CONDITIONS} element={<AcceptTerms />} />

              <Route path="*" element={<Navigate to="/my-caseload" />} />
            </Route>
          )
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
      </Routes >
      <ToastContainer
        closeOnClick
        pauseOnHover
      />
    </>
  );
}

export default App;
